export default "__VITE_PUBLIC_ASSET__87490a43__"